import React, { useMemo } from 'react';
import { Stack, Autocomplete, TextField, Checkbox, Skeleton, Alert } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useEndReasonTypeData } from '../contexts/EndReasonTypeDataContext';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const EndReasonTypeFilterControls = () => {
  const { 
    filter, 
    setFilter, 
    activeSchoolYear, 
    endReasonOptions, 
    optionsLoading,
    optionsError
  } = useEndReasonTypeData();

  const availableYears = useMemo(() => {
    if (!activeSchoolYear) return [];
    return Array.from({ length: 10 }, (_, i) => {
        const val = activeSchoolYear - i;
        return { value: val, label: `${val}-${val + 1}` };
    });
  }, [activeSchoolYear]);

  if (optionsLoading) {
    return (
        <Stack spacing={2} sx={{ mb: 2 }}>
            <Skeleton variant="rounded" height={40} />
            <Skeleton variant="rounded" height={40} />
        </Stack>
    );
  }

  if (optionsError) {
      return <Alert severity="error" sx={{ mb: 2 }}>{optionsError}</Alert>;
  }


  if (!activeSchoolYear && availableYears.length === 0) return null;

  const selectedYearOptions = availableYears.filter(y => filter.schoolYears.includes(y.value));
  const selectedTypeOptions = endReasonOptions.filter(t => filter.selectedEndReasonTypes?.includes(t.id));

  return (
    <Stack spacing={2} sx={{ mb: 2 }}>
      <Autocomplete
        multiple
        size="small"
        options={availableYears}
        value={selectedYearOptions}
        onChange={(_, newValue) => setFilter({ schoolYears: newValue.map(v => v.value) })}
        disableCloseOnSelect
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        limitTags={2}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox icon={icon} checkedIcon={checkedIcon} sx={{ marginRight: 8 }} checked={selected} />
            {option.label}
          </li>
        )}
        renderInput={(params) => <TextField {...params} label="School Year" placeholder="Select years" />}
      />

      <Autocomplete
        multiple
        size="small"
        options={endReasonOptions}
        value={selectedTypeOptions}
        onChange={(_, newValue) => setFilter({ selectedEndReasonTypes: newValue.map(v => v.id) })}
        disableCloseOnSelect
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        limitTags={2}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox icon={icon} checkedIcon={checkedIcon} sx={{ marginRight: 8 }} checked={selected} />
            {option.name}
          </li>
        )}
        renderInput={(params) => <TextField {...params} label="End Reason Type" placeholder="All Types" />}
      />
    </Stack>
  );
};